import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const resetPassWordApi = (data) =>
    Promise.resolve(axios.post(endpoints.resetPassword, data));
